import { render } from "./PvCalendar.vue?vue&type=template&id=1b86cf2e&scoped=true"
import script from "./PvCalendar.vue?vue&type=script&lang=js"
export * from "./PvCalendar.vue?vue&type=script&lang=js"

import "./PvCalendar.vue?vue&type=style&index=0&id=1b86cf2e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b86cf2e"]])

export default __exports__